'use client';

import { Check } from 'lucide-react';
import { QuizAnswerOption } from '@/types';

interface QuizSingleSelectProps {
  question: string;
  instruction?: string;
  options: QuizAnswerOption[];
  selectedValue?: string;
  onSelect: (value: string) => void;
}

export function QuizSingleSelect({
  question,
  instruction,
  options,
  selectedValue,
  onSelect,
}: QuizSingleSelectProps) {
  return (
    <div className="w-full max-w-2xl mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
          {question}
        </h1>
        {instruction && (
          <p className="text-gray-400 text-sm">{instruction}</p>
        )}
      </div>

      <div className="space-y-3">
        {options.map((option) => {
          const isSelected = selectedValue === option.value;

          return (
            <button
              key={option.value}
              onClick={() => onSelect(option.value)}
              className={`
                w-full p-4 rounded-xl text-left transition-all duration-200
                flex items-center justify-between gap-4
                ${
                  isSelected
                    ? 'bg-blue-600 text-white border-2 border-blue-500'
                    : 'bg-gray-800/50 text-white border-2 border-gray-700 hover:border-gray-600 hover:bg-gray-800/70'
                }
              `}
            >
              <div className="flex-1">
                <div className="font-medium">{option.label}</div>
                {option.description && (
                  <div className="text-sm opacity-80 mt-1">{option.description}</div>
                )}
              </div>

              {isSelected && (
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white flex items-center justify-center">
                  <Check size={16} className="text-blue-600" />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
